<template>
  <div id="app">
    <div v-wechat-title="$route.meta.title"></div>

        <router-view v-if='isRouterAlive'/>

  </div>
</template>

<script>
export default {
  name: 'App',
  provide(){
    return {
      reload: this.reload
    }
  },

  data(){
    return {
      isRouterAlive: true
    }
  },

  methods:{
    
    //注入自动刷新
    reload(){
      this.isRouterAlive = false;
      this.$nextTick(()=>{
        this.isRouterAlive = true;
      })
    }
  }
}
</script>

<style lang="scss">
  @import "styles/common";
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    /*margin-top: 60px;*/
  }
</style>


// WEBPACK FOOTER //
// src/App.vue